import { SellingUnitOfMeasure } from '@snap-types/models/enums';

/**
 * Re-exported so callers have a single import site. Both live in
 * `@snap-types/models/enums` because packages that cannot depend on `lib` —
 * notably `calculations` — need them, and because this module is pulled into
 * the browser bundle, where a `@prisma-client` import does not resolve.
 */
export { SELLING_UOM_MULTIPLIER } from '@snap-types/models/enums';

export const SELLING_UOM_OPTIONS = [
  {
    label: 'Each (EA)',
    value: SellingUnitOfMeasure.EA,
  },
  {
    label: 'Thousand (M)',
    value: SellingUnitOfMeasure.M,
  },
];

export const SELLING_UOM_DESCRIPTION = {
  [SellingUnitOfMeasure.EA]: '',
  [SellingUnitOfMeasure.M]: ' (in thousands)',
} satisfies Record<SellingUnitOfMeasure, string>;
